import React from 'react';
import includedIcon from "../../../../../styles/img/NewPackSelector/included-icon.svg";
import notIncludedIcon from "../../../../../styles/img/NewPackSelector/not-included-icon.svg";

const TableIcon = ({ isIncluded, hasThreePack }) => {
    const icon = isIncluded ? includedIcon : notIncludedIcon;
    return (
    <div className={`tableOption-container ${hasThreePack ? "three-packs" : ""}`}>
        <img src ={icon} alt="ok"></img>
    </div>
)}

export default TableIcon;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/TableIcon.js